import React from 'react';
import About from '../About';
import Footer from '../Footer';
import Header from '../Header';
import Newsletter from '../Newsletter';


const About2 = () => {
  return (
    <>
    <Header />
    <About />
    <Newsletter/>
    <Footer />
      
    </>
  )
}

export default About2
